import { Component, HostBinding, Input } from '@angular/core'

@Component({
    selector: 'mg-hero',
    templateUrl: './hero.component.html',
    styleUrls: ['./hero.component.scss'],
})
export class HeroComponent {
    @HostBinding('class._has_backdrop')
    @Input()
    backdropImage: string | false = 'assets/images/backdrops/hero.jpg'
}
